export const SfToken = () => {
  return (
    <>
      <div id="dexscreener-embed">
        <iframe src="https://dexscreener.com/solana/6nDgw6nGCMZttjZHBXUGBhXxy8cbSPGecZDEdYBgwDLX?embed=1&loadChartSettings=0&chartLeftToolbar=0&chartDefaultOnMobile=1&chartTheme=dark&theme=dark&chartStyle=0&chartType=usd&interval=15"></iframe>
      </div>
    </>
  );
};
